import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgMail = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 10" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#007AFF">
      <rect width={12.75} height={9} x={0.5} y={0.5} rx={2} />
      <path d="M1.365 1.614 7.04 4.55l5.274-2.936" />
    </g>
  </svg>
);
const Memo = memo(SvgMail);
export default Memo;
